import React from 'react';

type Props = React.SVGProps<SVGElement> & {
  fill1?: string;
  fill2?: string;
  fill3?: string;
  fill4?: string;
  fill5?: string;
}

export const Amazon = ({ className, fill1 = '#000', fill2 = '#FF9900' }: Props) => {
  return (
    <svg
      className={className}
      width="16px"
      height="16px"
      viewBox="0 0 16 16"
      fillRule="evenodd"
      clipRule="evenodd">
      <path
        d="M9.41912 6.62799C9.41912 7.43676 9.43956 8.11124 9.03077 8.82948C8.70082 9.41349 8.17817 9.77261 7.59423 9.77261C6.79709 9.77261 6.33285 9.16528 6.33285 8.26892C6.33285 6.49948 7.91827 6.17834 9.41912 6.17834V6.62799ZM11.5126 11.688C11.3754 11.8106 11.1768 11.8194 11.0221 11.7376C10.333 11.1654 10.2104 10.8997 9.8308 10.3537C8.69208 11.5158 7.8862 11.8632 6.40879 11.8632C4.66274 11.8632 3.30209 10.7858 3.30209 8.62804C3.30209 6.94335 4.21604 5.79583 5.51527 5.23527C6.64236 4.73884 8.21615 4.65126 9.41912 4.51408V4.24543C9.41912 3.75195 9.45704 3.16801 9.16802 2.74174C8.91395 2.35924 8.42928 2.20155 8.00295 2.20155C7.21172 2.20155 6.50511 2.60739 6.33285 3.44829C6.29777 3.6352 6.16058 3.81916 5.97373 3.8279L3.95903 3.61188C3.78971 3.57384 3.60286 3.43666 3.64957 3.17675C4.11381 0.735842 6.3182 0 8.29197 0C9.30225 0 10.622 0.268647 11.4191 1.03366C12.4294 1.97673 12.333 3.23515 12.333 4.60455V7.8397C12.333 8.812 12.7359 9.23827 13.1155 9.76387C13.2498 9.95073 13.279 10.1756 13.1097 10.3157C12.6863 10.669 11.933 11.326 11.5184 11.6939L11.5126 11.688Z"
        fill={fill1}
      />
      <path
        d="M13.774 12.9176C7.29727 16 3.27771 13.421 0.704667 11.8546C0.545448 11.7559 0.274832 11.8777 0.509629 12.1474C1.36684 13.1868 4.1761 15.692 7.843 15.692C11.5124 15.692 13.6954 13.6898 13.9685 13.3405C14.2397 12.9942 14.0482 12.8032 13.774 12.9176ZM15.593 11.913C15.4191 11.6866 14.5354 11.6443 13.9793 11.7127C13.4223 11.779 12.5863 12.1194 12.659 12.3238C12.6963 12.4004 12.7724 12.366 13.155 12.3316C13.5387 12.2933 14.6135 12.1577 14.8375 12.4505C15.0625 12.7453 14.4947 14.1496 14.391 14.3761C14.2908 14.6026 14.4293 14.661 14.6175 14.5102C14.8031 14.3594 15.1391 13.9689 15.3646 13.4162C15.5886 12.8606 15.7252 12.0855 15.593 11.913Z"
        fill={fill2}
      />
    </svg>
  );
};

export const Comparably = ({
  className,
  fill1 = '#F68923',
  fill2 = '#1A6178',
  fill3 = '#8BBD4A',
  fill4 = '#0F99B8',
  fill5 = '#A952A0',
}: Props) => {
  return (
    <svg
      className={className}
      width="16px"
      height="16px"
      viewBox="0 0 16 16"
      fillRule="evenodd"
      clipRule="evenodd">
      <path d="M4.00825 0L6.68041 5.27619H9.33608L11.9918 0H4.00825Z" fill={fill1} />
      <path d="M4.00825 0L6.68041 5.27619L5.31134 7.9619H0L4.00825 0Z" fill={fill2} />
      <path d="M0 7.96191H5.31134L6.68041 10.6286L4.00825 16L0 7.96191Z" fill={fill3} />
      <path d="M6.68041 10.6286H9.33608L11.9918 16H4.00825L6.68041 10.6286Z" fill={fill4} />
      <path d="M9.33608 10.6286L10.6392 7.96191H15.9505L11.9918 16L9.33608 10.6286Z" fill={fill5} />
    </svg>
  );
};

export const Facebook = ({ className, fill1 = '#4267B2' }: Props) => {
  return (
    <svg
      className={className}
      width="16px"
      height="16px"
      viewBox="0 0 16 16"
      fillRule="evenodd"
      clipRule="evenodd">
      <path
        d="M11.9993 0.00332903L9.92451 0C7.59352 0 6.08714 1.5455 6.08714 3.93758V5.75307H4.001C3.82073 5.75307 3.67475 5.89921 3.67475 6.07948V8.70992C3.67475 8.89018 3.8209 9.03616 4.001 9.03616H6.08714V15.6736C6.08714 15.8539 6.23311 15.9998 6.41338 15.9998H9.1352C9.31547 15.9998 9.46144 15.8537 9.46144 15.6736V9.03616H11.9006C12.0809 9.03616 12.2269 8.89018 12.2269 8.70992L12.2279 6.07948C12.2279 5.99293 12.1934 5.91003 12.1323 5.84878C12.0712 5.78752 11.988 5.75307 11.9015 5.75307H9.46144V4.21406C9.46144 3.47435 9.63772 3.09883 10.6013 3.09883L11.999 3.09833C12.1791 3.09833 12.3251 2.95219 12.3251 2.77209V0.329574C12.3251 0.14964 12.1793 0.00366194 11.9993 0.00332903Z"
        fill={fill1}
      />
    </svg>
  );
};

export const Glassdoor = ({ className, fill1 = '#0CAA41' }: Props) => {
  return (
    <svg
      className={className}
      width="16px"
      height="16px"
      viewBox="0 0 16 16"
      fillRule="evenodd"
      clipRule="evenodd">
      <path
        d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM5.14219 10.8578H9.71094V6.16406C9.71094 6.14062 9.72969 6.12187 9.75313 6.12187H10.8125C10.8359 6.12187 10.8547 6.14062 10.8547 6.16406V10.8578C10.8547 11.4891 10.3438 12 9.7125 12H6.28438C5.65313 12 5.14219 11.4891 5.14219 10.8578ZM10.8563 5.14219C10.8563 4.51094 10.3453 4 9.71406 4H6.28438C5.65313 4 5.14219 4.51094 5.14219 5.14219V9.83594C5.14219 9.85938 5.16094 9.87813 5.18438 9.87813H6.24375C6.26719 9.87813 6.28594 9.85938 6.28594 9.83594V5.14219H10.8563Z"
        fill={fill1}
        fillRule="evenodd"
        clipRule="evenodd"
      />
    </svg>
  );
};

export const GoogleIcon = ({ className }: Props) => {
  return (
    <svg className={className} viewBox="0 0 48 48" width="20px" height="20px">
      <path
        fill="#FFC107"
        d="M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12c0-6.627,5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24c0,11.045,8.955,20,20,20c11.045,0,20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z"
      />
      <path
        fill="#FF3D00"
        d="M6.306,14.691l6.571,4.819C14.655,15.108,18.961,12,24,12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C16.318,4,9.656,8.337,6.306,14.691z"
      />
      <path
        fill="#4CAF50"
        d="M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.211,35.091,26.715,36,24,36c-5.202,0-9.619-3.317-11.283-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z"
      />
      <path
        fill="#1976D2"
        d="M43.611,20.083H42V20H24v8h11.303c-0.792,2.237-2.231,4.166-4.087,5.571c0.001-0.001,0.002-0.001,0.003-0.002l6.19,5.238C36.971,39.205,44,34,44,24C44,22.659,43.862,21.35,43.611,20.083z"
      />
    </svg>
  );
};

export const GooglePlay = ({
  className,
  fill1 = '#63BE6B',
  fill2 = '#3EC6F2',
  fill3 = '#FBBB15',
  fill4 = '#EC3B50',
}: Props) => {
  return (
    <svg
      className={className}
      width="16px"
      height="16px"
      viewBox="0 0 16 16"
      fillRule="evenodd"
      clipRule="evenodd">
      <path
        d="M9.95083 4.86707L1.51304 0.0444991C1.40701 -0.0170657 1.27362 -0.0136454 1.17101 0.0479193C1.06499 0.109484 1 0.218933 1 0.342062C1 0.342062 1.00342 0.786697 1.00684 1.51863L7.15306 7.66485L9.95083 4.86707Z"
        fill={fill1}
      />
      <path
        d="M1.00684 1.51863C1.0171 4.15908 1.04788 10.5687 1.06156 13.7598L7.15648 7.66485L1.00684 1.51863Z"
        fill={fill2}
      />
      <path
        d="M14.7802 7.62723L9.95083 4.86707L7.14964 7.66485L10.31 10.8252L14.7837 8.21893C14.8897 8.15737 14.9547 8.0445 14.9547 7.92479C14.9547 7.80166 14.8863 7.68879 14.7802 7.62723V7.62723Z"
        fill={fill3}
      />
      <path
        d="M1.05814 13.7598C1.06498 14.8987 1.0684 15.6272 1.0684 15.6272C1.0684 15.7504 1.13339 15.8632 1.23942 15.9214C1.34545 15.9829 1.47542 15.9829 1.58144 15.9214L10.3134 10.8286L7.15306 7.66827L1.05814 13.7598Z"
        fill={fill4}
      />
    </svg>
  );
};

export const Instagram = ({ className, fill1 = '#0A0A08' }: Props) => {
  return (
    <svg
      className={className}
      width="16px"
      height="16px"
      viewBox="0 0 16 16"
      fillRule="evenodd"
      clipRule="evenodd">
      <path
        d="M7.99998 1.44147C10.1361 1.44147 10.3891 1.4496 11.2327 1.48809C12.0126 1.52369 12.4362 1.65401 12.7182 1.76354C13.0916 1.90867 13.3581 2.08205 13.638 2.36198C13.9179 2.64191 14.0913 2.90844 14.2364 3.28183C14.346 3.56376 14.4763 3.98735 14.5119 4.76731C14.5504 5.61091 14.5585 5.86391 14.5585 8.00002C14.5585 10.1361 14.5504 10.3891 14.5119 11.2327C14.4763 12.0127 14.346 12.4363 14.2364 12.7182C14.0913 13.0916 13.9179 13.3581 13.638 13.638C13.3581 13.918 13.0916 14.0914 12.7182 14.2365C12.4362 14.346 12.0126 14.4763 11.2327 14.5119C10.3892 14.5504 10.1362 14.5586 7.99998 14.5586C5.86375 14.5586 5.61075 14.5504 4.76731 14.5119C3.98732 14.4763 3.56373 14.346 3.28183 14.2365C2.90841 14.0914 2.64188 13.918 2.36195 13.638C2.08202 13.3581 1.90863 13.0916 1.76354 12.7182C1.65398 12.4363 1.52366 12.0127 1.48806 11.2327C1.44957 10.3891 1.44144 10.1361 1.44144 8.00002C1.44144 5.86391 1.44957 5.61091 1.48806 4.76735C1.52366 3.98735 1.65398 3.56376 1.76354 3.28183C1.90863 2.90844 2.08202 2.64191 2.36195 2.36198C2.64188 2.08205 2.90841 1.90867 3.28183 1.76354C3.56373 1.65401 3.98732 1.52369 4.76728 1.48809C5.61088 1.4496 5.86388 1.44147 7.99998 1.44147ZM7.99998 0C5.8273 0 5.5549 0.00920926 4.70161 0.0481422C3.85007 0.0870116 3.26855 0.222229 2.75966 0.420006C2.23359 0.624451 1.78745 0.897998 1.34271 1.34274C0.897966 1.78748 0.624419 2.23363 0.419974 2.7597C0.222197 3.26859 0.0869798 3.8501 0.0481104 4.70164C0.0091775 5.5549 0 5.82733 0 8.00002C0 10.1727 0.0091775 10.4451 0.0481104 11.2984C0.0869798 12.1499 0.222197 12.7314 0.419974 13.2403C0.624419 13.7664 0.897966 14.2125 1.34271 14.6573C1.78745 15.102 2.23359 15.3756 2.75966 15.58C3.26855 15.7778 3.85007 15.913 4.70161 15.9519C5.5549 15.9908 5.8273 16 7.99998 16C10.1727 16 10.4451 15.9908 11.2984 15.9519C12.1499 15.913 12.7314 15.7778 13.2403 15.58C13.7664 15.3756 14.2125 15.102 14.6573 14.6573C15.102 14.2125 15.3755 13.7664 15.58 13.2403C15.7778 12.7314 15.913 12.1499 15.9519 11.2984C15.9908 10.4451 16 10.1727 16 8.00002C16 5.82733 15.9908 5.5549 15.9519 4.70164C15.913 3.8501 15.7778 3.26859 15.58 2.7597C15.3755 2.23363 15.102 1.78748 14.6573 1.34274C14.2125 0.897998 13.7664 0.624451 13.2403 0.420006C12.7314 0.222229 12.1499 0.0870116 11.2984 0.0481422C10.4451 0.00920926 10.1727 0 7.99998 0ZM7.99998 3.89189C5.73114 3.89189 3.89186 5.73117 3.89186 8.00002C3.89186 10.2689 5.73114 12.1081 7.99998 12.1081C10.2688 12.1081 12.1081 10.2689 12.1081 8.00002C12.1081 5.73117 10.2688 3.89189 7.99998 3.89189ZM7.99998 10.6667C6.52723 10.6667 5.3333 9.47277 5.3333 8.00002C5.3333 6.52727 6.52723 5.33333 7.99998 5.33333C9.47273 5.33333 10.6667 6.52727 10.6667 8.00002C10.6667 9.47277 9.47273 10.6667 7.99998 10.6667ZM13.2304 3.72959C13.2304 4.25979 12.8006 4.68961 12.2704 4.68961C11.7402 4.68961 11.3104 4.25979 11.3104 3.72959C11.3104 3.19939 11.7402 2.7696 12.2704 2.7696C12.8006 2.7696 13.2304 3.19939 13.2304 3.72959Z"
        fill={fill1}
      />
    </svg>
  );
};

export const Pinterest = ({ className, fill1 = '#CA2127' }: Props) => {
  return (
    <svg
      className={className}
      width="16px"
      height="16px"
      viewBox="0 0 16 16"
      fillRule="evenodd"
      clipRule="evenodd">
      <path
        d="M7.97333 15.7689C12.2756 15.7689 15.7644 12.28 15.7644 7.97778C15.7644 3.67556 12.2756 0.186668 7.97333 0.186668C3.67111 0.186668 0.182222 3.67556 0.182222 7.97778C0.182222 11.2343 2.1812 14.0248 5.01879 15.1889C4.77874 13.3297 5.21026 11.7964 5.62986 10.3055C5.7839 9.75821 5.93633 9.21659 6.05333 8.66667C5.29778 7.45333 6.14667 5.00444 7.74222 5.60889C8.68297 5.96433 8.33231 7.01491 7.9818 8.06506C7.60038 9.20781 7.21913 10.3501 8.50222 10.5956C11.0711 11.0889 12.12 6.34667 10.5289 4.80444C8.22222 2.58222 3.82667 4.75556 4.36889 7.93778C4.43556 8.33333 5.08444 8.95556 5.08444 8.95556C5.08444 8.95556 5.05333 9.33333 4.88444 10.0311C3.40889 9.72 2.79111 8.61333 2.84889 7.13778C2.93778 4.72 5.12444 3.03111 7.32 2.79556C10.0933 2.49778 12.6978 3.76444 13.0622 6.25333C13.4667 9.06222 11.8089 12.1022 8.84 11.8844C8.23723 11.8412 7.89647 11.6157 7.49799 11.3521C7.36467 11.2638 7.22488 11.1714 7.06667 11.08C6.7321 12.7528 6.32715 14.3595 5.16865 15.2486C6.03895 15.5846 6.98466 15.7689 7.97333 15.7689Z"
        fill={fill1}
      />
    </svg>
  );
};

export const Quora = ({ className, fill1 = '#B92B27' }: Props) => {
  return (
    <svg
      className={className}
      width="16px"
      height="16px"
      viewBox="0 0 16 16"
      fillRule="evenodd"
      clipRule="evenodd">
      <path
        d="M8.21806 12.457C7.66453 11.3675 7.01519 10.2671 5.74854 10.2671C5.50641 10.2671 5.26457 10.3072 5.04264 10.4085L4.61234 9.54733C5.13672 9.09741 5.98404 8.74071 7.0732 8.74071C8.76755 8.74071 9.63708 9.55685 10.3274 10.5987C10.7372 9.70923 10.932 8.5081 10.932 7.01923C10.932 3.30125 9.76926 1.39219 7.05329 1.39219C4.37685 1.39219 3.22044 3.30125 3.22044 7.01923C3.22044 10.7176 4.37685 12.607 7.05329 12.607C7.47868 12.607 7.86395 12.5603 8.21806 12.457ZM8.88154 13.7545C8.2853 13.9149 7.67072 13.9969 7.05329 13.9986C3.48941 13.9986 0 11.1548 0 7.01923C0 2.8444 3.48941 0 7.05329 0C10.6769 0 14.1328 2.82391 14.1328 7.01923C14.1328 9.35282 13.044 11.2492 11.4613 12.4748C11.9727 13.2411 12.4991 13.7499 13.2321 13.7499C14.0321 13.7499 14.3548 13.1317 14.4087 12.6469H15.4506C15.5115 13.2924 15.1885 15.9755 12.2769 15.9755C10.5133 15.9755 9.58081 14.9533 8.88154 13.7545Z"
        fill={fill1}
      />
    </svg>
  );
};

export const Reddit = ({ className, fill1 = '#FF4500' }: Props) => {
  return (
    <svg
      className={className}
      width="16px"
      height="16px"
      viewBox="0 0 16 16"
      fillRule="evenodd"
      clipRule="evenodd">
      <path
        d="M5.5704 9.3656C5.496 9.2914 5.4372 9.2032 5.3968 9.1062C5.3566 9.009 5.336 8.905 5.336 8.8C5.336 8.4764 5.531 8.1848 5.8298 8.0608C6.1288 7.937 6.4728 8.0056 6.7016 8.2344C6.9304 8.4632 6.999 8.8072 6.8752 9.1062C6.7512 9.405 6.4596 9.6 6.136 9.6C6.03093 9.60001 5.92689 9.57935 5.8298 9.5392C5.7328 9.4988 5.6446 9.44 5.5704 9.3656Z"
        fill={fill1}
      />
      <path
        d="M10.044 10.8748C10.0432 10.932 10.0198 10.9866 9.9788 11.0266L9.984 11C9.8434 11.106 9.694 11.1996 9.5374 11.28C9.2235 11.4409 8.8843 11.5466 8.5346 11.5926C8.36 11.6154 8.1838 11.6232 8.008 11.616C7.8322 11.6232 7.656 11.6154 7.4814 11.5926C7.3068 11.5696 7.1346 11.5318 6.9666 11.4794C6.7986 11.427 6.6352 11.3604 6.4786 11.28C6.322 11.1996 6.1726 11.106 6.032 11C5.998 10.9586 5.9806 10.906 5.9832 10.8524C5.9858 10.7988 6.0084 10.7482 6.0462 10.7102C6.0842 10.6724 6.1348 10.6498 6.1884 10.6472C6.242 10.6446 6.2946 10.662 6.336 10.696C6.4552 10.7834 6.5816 10.8606 6.7138 10.9266C6.846 10.9926 6.9834 11.0474 7.125 11.0902C7.26637 11.1332 7.41116 11.164 7.5578 11.1822C7.7044 11.2006 7.8524 11.2066 8 11.2C8.1478 11.208 8.296 11.2036 8.4432 11.1866C8.5902 11.1696 8.7356 11.1402 8.8776 11.0988C9.01972 11.0573 9.15808 11.0038 9.2912 10.939C9.42432 10.8742 9.5517 10.7983 9.672 10.712C9.7182 10.6774 9.7734 10.6552 9.8308 10.656C9.888 10.6568 9.9426 10.6802 9.9826 10.7212C10.0226 10.7622 10.0448 10.8174 10.044 10.8748Z"
        fill={fill1}
      />
      <path
        d="M10.1482 9.6026C10.048 9.6442 9.9404 9.6652 9.832 9.664L9.84 9.632C9.5164 9.632 9.2248 9.437 9.1008 9.1382C8.977 8.8392 9.0456 8.4952 9.2744 8.2664C9.5032 8.0376 9.8472 7.969 10.1462 8.0928C10.445 8.2168 10.64 8.5084 10.64 8.832C10.6444 8.94038 10.6266 9.04852 10.5878 9.1498C10.549 9.2512 10.4902 9.3436 10.4146 9.4214C10.339 9.4992 10.2484 9.5608 10.1482 9.6026Z"
        fill={fill1}
      />
      <path
        d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM13.2952 8.3248C13.324 8.219 13.3376 8.1096 13.336 8C13.3278 7.77478 13.2546 7.55674 13.1252 7.3722C12.9959 7.18768 12.8159 7.04452 12.607 6.96C12.3981 6.87544 12.1693 6.85314 11.948 6.8958C11.7267 6.93831 11.5225 7.04396 11.36 7.2C11.134 7.04636 10.8972 6.9092 10.6514 6.7896C10.1594 6.54986 9.63529 6.3824 9.0954 6.2924C8.8258 6.2474 8.5532 6.2218 8.28 6.216L8.8 3.72L10.512 4.08C10.554 4.4708 10.8738 4.7732 11.2664 4.7934C11.6588 4.8136 12.008 4.5456 12.0898 4.1612C12.1718 3.7768 11.9622 3.3898 11.5956 3.2482C11.229 3.1066 10.8138 3.2522 10.616 3.592L8.656 3.2C8.624 3.193 8.5908 3.1924 8.5586 3.1982C8.5262 3.2042 8.4954 3.2164 8.4678 3.2342C8.4404 3.252 8.4166 3.2752 8.3982 3.3022C8.3796 3.3294 8.3666 3.3598 8.36 3.392L7.768 6.168C7.4914 6.1722 7.2154 6.1964 6.9424 6.2406C6.6694 6.2848 6.3998 6.3486 6.136 6.4318C5.8722 6.515 5.6148 6.6174 5.3658 6.7378C5.11686 6.85838 4.87697 6.99681 4.648 7.152C4.52466 7.03597 4.37757 6.94815 4.21691 6.89462C4.05626 6.8411 3.88588 6.82314 3.7176 6.842C3.54934 6.86078 3.38718 6.91595 3.24237 7.00367C3.09756 7.09139 2.97357 7.20957 2.879 7.35C2.78435 7.49046 2.72137 7.64982 2.69444 7.81704C2.6675 7.98425 2.67725 8.15533 2.723 8.3184C2.76883 8.48141 2.84953 8.6325 2.95952 8.76124C3.0695 8.88998 3.20615 8.99328 3.36 9.064C3.3578 9.0932 3.356 9.1226 3.355 9.152C3.35259 9.21064 3.35259 9.26936 3.355 9.328C3.356 9.3574 3.3578 9.3868 3.36 9.416C3.36 11.208 5.448 12.664 8.024 12.664C10.6 12.664 12.688 11.208 12.688 9.416C12.6902 9.3868 12.692 9.3574 12.693 9.328C12.6954 9.26936 12.6954 9.21064 12.693 9.152C12.692 9.1226 12.6902 9.0932 12.688 9.064C12.7862 9.0152 12.877 8.9528 12.9578 8.8786C13.0386 8.8044 13.1086 8.7192 13.1656 8.6256C13.2228 8.532 13.2664 8.4306 13.2952 8.3248Z"
        fill={fill1}
      />
    </svg>
  );
};

export const SiteJabber = ({ className, fill1 = '#F06A22' }: Props) => {
  return (
    <svg
      className={className}
      width="16px"
      height="16px"
      viewBox="0 0 16 16"
      fillRule="evenodd"
      clipRule="evenodd">
      <path
        d="M14.6359 8.28796C14.6359 9.9502 14.0772 11.4824 13.1365 12.7085L16 15.5759H7.31793C3.27635 15.5759 0 12.313 0 8.28796C0 4.26293 3.27635 1 7.31793 1C11.3595 1 14.6359 4.26293 14.6359 8.28796ZM8.64042 6.17578C8.70986 6.30323 8.831 6.39445 8.97265 6.42598L11.329 6.95032C11.4551 6.97837 11.5033 7.13258 11.4157 7.2275L9.82182 8.95384C9.72197 9.06199 9.67456 9.2085 9.69206 9.3546L9.98635 11.8106C10.002 11.9414 9.86773 12.0382 9.74861 11.9821L7.53378 10.9384C7.39719 10.8741 7.23889 10.8745 7.10268 10.9397L4.92814 11.9797C4.80896 12.0366 4.67379 11.9397 4.68951 11.8086L4.98322 9.3577C5.00095 9.20976 4.95216 9.06162 4.85001 8.9532L3.22465 7.228C3.13554 7.13341 3.18336 6.97779 3.3102 6.94957L5.66321 6.42598C5.80488 6.39445 5.926 6.30323 5.99542 6.17578L7.17081 4.01802C7.23428 3.90149 7.40158 3.90149 7.46506 4.01802L8.64042 6.17578Z"
        fill={fill1}
      />
    </svg>
  );
};

export const TikTok = ({ className, fill1 = '#000' }: Props) => {
  return (
    <svg
      className={className}
      width="16px"
      height="16px"
      viewBox="0 0 16 16"
      fillRule="evenodd"
      clipRule="evenodd">
      <path
        d="M8.36999 0.0135C9.24249 0 10.11 0.008 10.9765 0C11.029 1.0205 11.396 2.06 12.143 2.7815C12.8885 3.521 13.943 3.8595 14.969 3.974V6.6585C14.0075 6.627 13.0415 6.427 12.169 6.013C11.789 5.841 11.435 5.6195 11.0885 5.393C11.084 7.341 11.0965 9.2865 11.076 11.2265C11.024 12.1585 10.7165 13.086 10.1745 13.854C9.30249 15.1325 7.78899 15.966 6.23449 15.992C5.28099 16.0465 4.32849 15.7865 3.51599 15.3075C2.16949 14.5135 1.22199 13.06 1.08399 11.5C1.06799 11.1665 1.06249 10.8335 1.07599 10.508C1.19599 9.2395 1.82349 8.026 2.79749 7.2005C3.90149 6.239 5.44799 5.781 6.89599 6.052C6.90949 7.0395 6.86999 8.026 6.86999 9.0135C6.20849 8.7995 5.43549 8.8595 4.85749 9.261C4.43549 9.5345 4.11499 9.9535 3.94799 10.4275C3.80999 10.7655 3.84949 11.141 3.85749 11.5C4.01599 12.594 5.06799 13.5135 6.19099 13.414C6.93549 13.406 7.64899 12.974 8.03699 12.3415C8.16249 12.12 8.30299 11.8935 8.31049 11.633C8.37599 10.4405 8.34999 9.253 8.35799 8.0605C8.36349 5.373 8.34999 2.693 8.37049 0.014L8.36999 0.0135Z"
        fill={fill1}
      />
    </svg>
  );
};

export const TrustPilot = ({ className, fill1 = '#00B67A', fill2 = '#005128' }: Props) => {
  return (
    <svg
      className={className}
      width="16px"
      height="16px"
      viewBox="0 0 16 16"
      fillRule="evenodd"
      clipRule="evenodd">
      <path
        d="M16 5.81211H9.88727L8.00557 0L6.11273 5.81211L0 5.80097L4.94363 9.39736L3.0508 15.2095L7.99443 11.6131L12.9381 15.2095L11.0564 9.39736L16 5.81211Z"
        fill={fill1}
      />
      <path d="M11.4795 10.7112L11.0564 9.39735L8.00557 11.6131L11.4795 10.7112Z" fill={fill2} />
    </svg>
  );
};

export const Twitter = ({ className, fill1 = '#1DA1F2' }: Props) => {
  return (
    <svg
      className={className}
      width="16px"
      height="16px"
      viewBox="0 0 16 16"
      fillRule="evenodd"
      clipRule="evenodd">
      <path
        d="M16.016 2.52964C15.4271 2.79732 14.7923 2.97323 14.1345 3.05736C14.8076 2.65201 15.3277 2.00956 15.5724 1.23709C14.9376 1.6195 14.234 1.88719 13.4921 2.04015C12.8879 1.38241 12.0389 1 11.0753 1C9.27794 1 7.80949 2.46845 7.80949 4.28107C7.80949 4.54111 7.84008 4.7935 7.89362 5.03059C5.17087 4.89293 2.74639 3.58509 1.13263 1.60421C0.849643 2.08604 0.689032 2.65201 0.689032 3.24857C0.689032 4.38815 1.26265 5.39771 2.14983 5.97132C1.60681 5.97132 1.10203 5.81836 0.658439 5.58891C0.658439 5.58891 0.658439 5.58891 0.658439 5.61186C0.658439 7.20268 1.79037 8.53346 3.28941 8.83174C3.01408 8.90822 2.72345 8.94646 2.42517 8.94646C2.21867 8.94646 2.01217 8.92352 1.81331 8.88528C2.22632 10.1778 3.42708 11.1415 4.87259 11.1644C3.75595 12.0516 2.34104 12.5717 0.796106 12.5717C0.536068 12.5717 0.276029 12.5564 0.0159912 12.5258C1.46915 13.4589 3.19764 14.0019 5.0485 14.0019C11.0753 14.0019 14.3869 9 14.3869 4.66348C14.3869 4.51817 14.3869 4.3805 14.3793 4.23518C15.0217 3.77629 15.5724 3.19503 16.016 2.52964Z"
        fill={fill1}
      />
    </svg>
  );
};

export const Youtube = ({ className, fill1 = '#000' }: Props) => {
  return (
    <svg
      className={className}
      width="16px"
      height="16px"
      viewBox="0 0 16 16"
      fillRule="evenodd"
      clipRule="evenodd">
      <path
        d="M6.41599 12V4.8L11.216 8.4M14.416 2.32C13.936 2.16 10.976 2 8.01599 2C5.05599 2 2.09599 2.152 1.61599 2.304C0.367991 2.72 0.0159912 5.52 0.0159912 8.4C0.0159912 11.272 0.367991 14.08 1.61599 14.488C2.09599 14.648 5.05599 14.8 8.01599 14.8C10.976 14.8 13.936 14.648 14.416 14.488C15.664 14.08 16.016 11.272 16.016 8.4C16.016 5.52 15.664 2.728 14.416 2.32Z"
        fill={fill1}
      />
    </svg>
  );
};

export const Apple = ({ className, fill1 = '#000' }: Props) => {
  return (
    <svg
      className={className}
      width="16px"
      height="16px"
      viewBox="0 0 16 16"
      fillRule="evenodd"
      clipRule="evenodd">
      <path
        d="M7.81002 3.87109C8.69368 3.87109 9.46887 3.52603 10.1356 2.83589C10.8023 2.14575 11.1357 1.34324 11.1357 0.428362C11.1357 0.327882 11.1277 0.185095 11.1118 0C10.9954 0.0158653 10.9081 0.0290863 10.8499 0.0396632C10.035 0.156008 9.31806 0.555284 8.69896 1.23747C8.07988 1.91968 7.77034 2.64948 7.77034 3.42688C7.77034 3.51677 7.78356 3.66486 7.81002 3.87109V3.87109ZM10.9769 16C11.6066 16 12.3024 15.569 13.0644 14.707C13.8263 13.845 14.4084 12.8323 14.8105 11.6688C13.3131 10.8967 12.5643 9.7888 12.5643 8.34506C12.5643 7.13932 13.1702 6.10809 14.3819 5.25137C13.5406 4.19897 12.4294 3.67277 11.0484 3.67277C10.4663 3.67277 9.93452 3.76003 9.453 3.93455L9.15139 4.04561L8.74659 4.20426C8.48202 4.30474 8.24126 4.355 8.02432 4.355C7.85499 4.355 7.63274 4.29681 7.35761 4.18046L7.04805 4.05354L6.75439 3.93455C6.32578 3.75475 5.86543 3.66484 5.37334 3.66484C4.05578 3.66484 2.99751 4.10907 2.1985 4.99752C1.39949 5.88596 1 7.05735 1 8.51165C1 10.5582 1.64025 12.4489 2.92077 14.1834C3.80973 15.3945 4.62196 16 5.35746 16C5.66966 16 5.9792 15.9392 6.2861 15.8175L6.67502 15.6589L6.98457 15.5478C7.41846 15.3945 7.81795 15.3178 8.18306 15.3178C8.56933 15.3178 9.01381 15.4156 9.5165 15.6113L9.76254 15.7065C10.2758 15.9022 10.6806 16 10.9769 16Z"
        fill={fill1}
      />
    </svg>
  );
};
